"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _gbp = _interopRequireDefault(require("gbp"));
var _occasion = _interopRequireDefault(require("occasion"));
var _alert = _interopRequireDefault(require("../core/alert"));
var _input = _interopRequireDefault(require("../core/input"));
var _link = _interopRequireDefault(require("../core/link"));
var _table = _interopRequireDefault(require("../core/table"));
var _col = _interopRequireDefault(require("../core/col"));
var _row = _interopRequireDefault(require("../core/row"));
var _modal = _interopRequireDefault(require("../core/modal"));
var _button = _interopRequireDefault(require("../core/button"));
var _linkButton = _interopRequireDefault(require("../core/link-button"));
var _success = _interopRequireDefault(require("./success"));
var _constantParams = require("../../constant-params");
var _StripePaymentContainer = _interopRequireDefault(require("../core/StripePaymentContainer"));
var _StripeCheckoutForm = _interopRequireDefault(require("../core/StripeCheckoutForm"));
var _ParticipationStatement = _interopRequireDefault(require("../articles/ParticipationStatement"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("span", null, "Please tick to confirm that you accept our", ' ', /*#__PURE__*/_react.default.createElement(_link.default, {
  className: "nav-item nav-link",
  activeClassName: "active",
  to: "/articles/terms/"
}, "Terms"), ' and ', /*#__PURE__*/_react.default.createElement(_link.default, {
  className: "nav-item nav-link",
  activeClassName: "active",
  to: "/articles/privacy/"
}, "Privacy Policy"), ' ', "and to confirm that that all of the participants entered above and their guardians (where the paddler is under 18) understand and accept the \"Participation Statement\".");
var _ref2 = /*#__PURE__*/_react.default.createElement("h2", null, "Checkout");
var _ref3 = /*#__PURE__*/_react.default.createElement(_success.default, null);
var _ref4 = /*#__PURE__*/_react.default.createElement("p", null, "You have no entries to pay for.");
var _ref5 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Race"), /*#__PURE__*/_react.default.createElement("th", null, "Bib"), /*#__PURE__*/_react.default.createElement("th", null, "Paddler"), /*#__PURE__*/_react.default.createElement("th", null, "Age"), /*#__PURE__*/_react.default.createElement("th", null, "Club"), /*#__PURE__*/_react.default.createElement("th", null, "Day"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Entry Fee"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Late Fee"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Online Booking Fee")));
var _ref6 = /*#__PURE__*/_react.default.createElement("td", null);
var _ref7 = /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right",
  colSpan: 6
}, "Estimated Total*");
var _ref8 = /*#__PURE__*/_react.default.createElement(_alert.default, null, /*#__PURE__*/_react.default.createElement(_ParticipationStatement.default, null));
var _ref9 = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header lead"
}, "Payment Details");
var _ref10 = /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
  xs: 12
}, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("p", {
  className: "small"
}, "*This is the total charge and in most cases will not change. However, in occasional circumstances it may be modified, eg if you are in div 3 and promoted before a 2/3 competition you may be charged at the div 2 rate to reflect the change to your entry.")));
class CheckoutBasket extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      conditionsAccepted: false,
      checkoutInProgress: false,
      checkoutCompleted: false,
      error: null
    });
    _defineProperty(this, "_onErrorDismissed", () => {
      this.setState({
        error: null
      });
    });
    _defineProperty(this, "_onToggleAcceptance", () => {
      const conditionsAccepted = !this.state.conditionsAccepted;
      this.setState({
        conditionsAccepted
      });
    });
    _defineProperty(this, "_getAcceptanceText", () => {
      return _ref;
    });
  }
  componentDidMount() {
    this.props.updateIsLateFlags();
  }
  render() {
    if (!this.props.loaded) return _ref2;
    const dismissErrorButton = /*#__PURE__*/_react.default.createElement(_button.default, {
      "data-test-id": "dismiss-error-button",
      onClick: this._onErrorDismissed
    }, "OK");
    const basket = this.props.basket;
    if (basket.itemCount === 0) {
      if (this.state.checkoutCompleted) return _ref3;
      const today = new Date();
      const MYENTRIES_URL = `/year/${_constantParams.thisYear}/my-account`;
      return /*#__PURE__*/_react.default.createElement("div", null, _ref4, /*#__PURE__*/_react.default.createElement(_linkButton.default, {
        to: MYENTRIES_URL,
        type: "primary",
        block: true
      }, "See entries for this and other years at 'My Account'"));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      style: this.state.checkoutInProgress ? {
        pointerEvents: 'none'
      } : {}
    }, !this.state.error ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: dismissErrorButton,
      onClose: this.props.onCheckoutErrorDismissed
    }, this.state.error), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card card-info card-block",
      style: {
        marginBottom: 20
      }
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "clearfix"
    }, "Total Entry Fees:", /*#__PURE__*/_react.default.createElement("span", {
      className: "pull-xs-right"
    }, (0, _gbp.default)(basket.entryFeesGrandTotal))), /*#__PURE__*/_react.default.createElement("p", {
      className: "clearfix"
    }, "Total Late Fees:", /*#__PURE__*/_react.default.createElement("span", {
      className: "pull-xs-right"
    }, (0, _gbp.default)(basket.lateFeesGrandTotal))), !basket.feeAdjustmentsGrandTotal ? null : /*#__PURE__*/_react.default.createElement("p", {
      className: "clearfix"
    }, "Fee Adjustments/Discounts:", basket.feeAdjustmentsGrandTotal < 0 ? /*#__PURE__*/_react.default.createElement("span", {
      className: "pull-xs-right"
    }, '(' + (0, _gbp.default)(basket.feeAdjustmentsGrandTotal * -1) + ')') : /*#__PURE__*/_react.default.createElement("span", {
      className: "pull-xs-right"
    }, (0, _gbp.default)(basket.feeAdjustmentsGrandTotal))), /*#__PURE__*/_react.default.createElement("p", {
      className: "clearfix"
    }, "Total Online Booking Fee:", /*#__PURE__*/_react.default.createElement("span", {
      className: "pull-xs-right"
    }, (0, _gbp.default)(basket.transactionFeesGrandTotal))), /*#__PURE__*/_react.default.createElement("p", {
      className: "clearfix"
    }, /*#__PURE__*/_react.default.createElement("strong", null, "Total Due", /*#__PURE__*/_react.default.createElement("span", {
      className: "pull-xs-right"
    }, '*' + (0, _gbp.default)(basket.grandTotal))))))), basket.basketCompetitions.map(basketCompetition => /*#__PURE__*/_react.default.createElement("div", {
      key: basketCompetition.id
    }, /*#__PURE__*/_react.default.createElement("h3", null, basketCompetition.competition.competitionName), /*#__PURE__*/_react.default.createElement(_table.default, null, _ref5, /*#__PURE__*/_react.default.createElement("tbody", null, basketCompetition.basketEntries.map(basketEntry => /*#__PURE__*/_react.default.createElement("tr", {
      key: basketEntry.id
    }, /*#__PURE__*/_react.default.createElement("td", null, basketEntry.entry.race.raceName), /*#__PURE__*/_react.default.createElement("td", null, basketEntry.entry.startListBib), /*#__PURE__*/_react.default.createElement("td", null, basketEntry.entry.bibName), /*#__PURE__*/_react.default.createElement("td", null, basketEntry.entry.ageCategoryDescription), /*#__PURE__*/_react.default.createElement("td", null, basketEntry.entry.clubName), /*#__PURE__*/_react.default.createElement("td", null, (0, _occasion.default)(basketEntry.entry.race.competitionDay.dayDate, 'ddd D MMM')), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, (0, _gbp.default)(basketEntry.entryFee)), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, basketEntry.lateFee ? (0, _gbp.default)(basketEntry.lateFee) : ''), _ref6)), basketCompetition.basketFeeAdjustments.map(basketFeeAdjustment => /*#__PURE__*/_react.default.createElement("tr", {
      key: basketFeeAdjustment.id
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right",
      colSpan: 6
    }, /*#__PURE__*/_react.default.createElement("em", null, basketFeeAdjustment.feeAdjustmentDescription)), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, basketFeeAdjustment.feeAdjustment < 0 ? '(' + (0, _gbp.default)(basketFeeAdjustment.feeAdjustment * -1) + ')' : (0, _gbp.default)(basketFeeAdjustment.feeAdjustment)))), /*#__PURE__*/_react.default.createElement("tr", null, _ref7, /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(basketCompetition.entryFeesTotal + basketCompetition.feeAdjustmentsTotal)), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(basketCompetition.lateFeesTotal)), /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(basketCompetition.transactionFees))))))), _ref8, /*#__PURE__*/_react.default.createElement(_StripeCheckoutForm.default, {
      "data-test-id": "checkout-form",
      onCheckout: async ({
        paymentMethodID,
        setupIntentID
      }) => {
        if (!this.state.conditionsAccepted) throw new Error('Please accept the terms and conditions');
        return await this.props.onCheckout(paymentMethodID, setupIntentID, this.props.basket.grandTotal, this.state.conditionsAccepted);
      },
      onCheckoutStart: () => this.setState({
        checkoutInProgress: true
      }),
      onCheckoutSuccess: () => this.setState({
        checkoutInProgress: false,
        checkoutCompleted: true
      }),
      onCheckoutError: error => this.setState({
        checkoutInProgress: false,
        error
      })
    }, ({
      checkoutInProgress
    }) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_alert.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      checked: this.state.conditionsAccepted,
      onChange: this._onToggleAcceptance,
      label: this._getAcceptanceText(),
      name: "acceptance-checkbox"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref9, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_StripePaymentContainer.default, {
      submitButtonLabel: 'PAY NOW ' + (0, _gbp.default)(basket.grandTotal) + ' (estimated*)',
      loading: checkoutInProgress
    }))))), _ref10));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(CheckoutBasket, "partials", {
  Basket: {
    itemCount: true,
    entryFeesGrandTotal: true,
    lateFeesGrandTotal: true,
    transactionFeesGrandTotal: true,
    feeAdjustmentsGrandTotal: true,
    grandTotal: true,
    basketCompetitions: {
      id: true,
      entryFeesTotal: true,
      lateFeesTotal: true,
      feeAdjustmentsTotal: true,
      transactionFees: true,
      total: true,
      competition: {
        competitionName: true
      },
      basketEntries: {
        id: true,
        entryFee: true,
        lateFee: true,
        entry: {
          race: {
            raceName: true,
            competitionDay: {
              dayDate: true
            }
          },
          startListBib: true,
          bibName: true,
          ageCategoryDescription: true,
          clubName: true,
          isLateEntry: true
        }
      },
      basketFeeAdjustments: {
        id: true,
        feeAdjustmentDescription: true,
        feeAdjustment: true
      }
    }
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(CheckoutBasket, null, (client, props) => ({
  onCheckout(paymentMethodID, setupIntentID, grandTotal, conditionsAccepted) {
    return client.update('Basket.checkout', {
      grandTotal,
      paymentMethodID,
      setupIntentID,
      conditionsAccepted
    });
  },
  updateIsLateFlags() {
    return client.update('Basket.updateIsLateFlags');
  }
}), {
  renderLoading: true
});